export const RELOAD_CLIENTS_AND_AFFILIATES = "RELOAD_CLIENTS_AND_AFFILIATES";
export const RELOAD_ADS = "RELOAD_ADS";

export const STORAGE = "STORAGE";